import React from "react";
import { Form, Input, Button, Icon, message, Checkbox, Alert,Row,Col } from 'antd';
import NHFormItem from '../common/NHFormItem';
import NHSelect from '../common/NHSelect';
const FormItem = Form.Item;
import NHFetch from "../../utils/NHFetch";

const baseUrlPath = "/studentPhoto"; //基础路径
const CheckboxGroup = Checkbox.Group;

const defaultStudent = [
    { label: '计算机学院', value: 'yxmc' },
    { label: '计算机科学与技术', value: 'zymc' },
    { label: '计算机1202班', value: 'bjmc' },
    { label: '2018', value: 'rxnf' },
    { label: '201811111', value: 'xh' },
    { label: '张三', value: 'xm' },
    { label: '17111111', value: 'ksh' },
    { label: '430111111111111111', value: 'sfzjh' },
];
const defaultCheckedList = [
    { label: '学院名称', value: 'yxmc' },
    { label: '专业名称', value: 'zymc' },
    { label: '班级名称', value: 'bjmc' },
    { label: '入学年份', value: 'rxnf' },
    { label: '学号', value: 'xh' },
    { label: '姓名', value: 'xm' },
    { label: '考生号', value: 'ksh' },
    { label: '身份证号', value: 'sfzjh' },
];

const formatDefaultCheckedList = <Row>
    <Col span={8}><Checkbox value="yxmc">学院名称</Checkbox></Col>
    <Col span={8}><Checkbox value="zymc">专业名称</Checkbox></Col>
    <Col span={8}><Checkbox value="bjmc">班级名称</Checkbox></Col>
    <Col span={8}><Checkbox value="rxnf">入学年份</Checkbox></Col>
    <Col span={8}><Checkbox value="xh">学号</Checkbox></Col>
    <Col span={8}><Checkbox value="xm">姓名</Checkbox></Col>
    <Col span={8}><Checkbox value="ksh">考生号</Checkbox></Col>
    <Col span={8}><Checkbox value="sfzjh">身份证号</Checkbox></Col>
</Row>


/**
 * studentPhoto编辑表单
 * @author Xiafanglin
 * @date 2018-03-10 03:51:42
 * Version: 1.0
 */
class DownloadForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visiable: true,
        }
    }
    onChange = (checkedArray) => {
        if (checkedArray && checkedArray.length > 0) {
            let gz = '';
            let sl = '';
            checkedArray.map(item => {
                defaultCheckedList.map(it => {
                    if (item == it.value) {
                        gz += it.label + "_";
                    }
                });
                defaultStudent.map(obj => {
                    if (item == obj.value) {
                        sl += obj.label + "_";
                    }
                });
            });
            gz = gz.substring(0, gz.length - 1);
            sl = sl.substring(0, sl.length - 1);
            this.props.form.setFieldsValue({ 'gz': gz, 'sl': sl });
        } else {
            this.props.form.setFieldsValue({ 'gz': '', 'sl': '' });
        }
    }
    handleClose = () => {
        this.setState({ visiable: false });
    }
    render() {
        const { getFieldDecorator, setFieldsValue } = this.props.form;
        const initFormData = this.props.initFormData;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
                md: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 15 },
            }
        };//表单项布局
        const message = "点击下载后，将会下载当前查询的" + this.props.count + "条学生数据中已上传的照片！";
        return (
            <div>
                {/* <div>
                    <span style={{color:"red"}}>注： 下载的是当前可以查询到的所有学生！
                        </span>
                </div>
                <Divider /> */}
                <div style={{ margin: "16px" }}>
                    <Form layout="horizontal">
                        <div style={{ display: this.state.visiable ? "block" : "none" }} >
                            <FormItem wrapperCol={{ xs: { span: 24 }, sm: { span: 12, offset: 6 }, md: { span: 18, offset: 3 } }} >
                                <Alert
                                    message={message}
                                    type="info"
                                    closable
                                    showIcon
                                    afterClose={this.handleClose}
                                />
                            </FormItem>
                        </div>
                        <NHFormItem id={"zhlx"} label={"照片命名可选字段:"} required={true}
                            form={this.props.form} formItemLayout={formItemLayout}>
                            <CheckboxGroup  onChange={this.onChange}>
                                {formatDefaultCheckedList}
                            </CheckboxGroup>
                        </NHFormItem>
                        <NHFormItem id={"gz"} label={"照片名生成规则:"}
                            form={this.props.form} formItemLayout={formItemLayout} >
                            <input class={"ant-input"} disabled={"true"} style={{ width: 450, height: 30 }} />
                        </NHFormItem>
                        <NHFormItem id={"sl"} label={"照片名示例:"}
                            form={this.props.form} formItemLayout={formItemLayout}>
                            <input class={"ant-input"} disabled={"true"} style={{ width: 450, height: 30 }} />
                        </NHFormItem>
                    </Form>
                </div>

            </div>
        );
    }
}

const Download = Form.create()(DownloadForm);

export default Download;


// WEBPACK FOOTER //
// ./components/stuPhotoMng/download.js